import React from 'react';
import { Link } from 'react-router-dom';
import Technumnewlogowhite from '../../assets/Images/Technumopus/footerLogo.webp';
import FooterliMail from '../../assets/Images/Technumopus/footerli_mail.svg';
import FooterliPhone from '../../assets/Images/Technumopus/footerli_phone.svg';
import AwsLogo from '../../assets/Images/Technumopus/awslogo2.webp';
import {
  FormField,
  FormSelect,
  FormTextarea,
  SubmitButton,
  FormStatus,
  useContactForm,
  SERVICE_OPTIONS,
  validateRequired,
  validateEmail,
} from '../../components/Forms';
import '../../components/Forms/Forms.css';
import './Footer.css';

const QUICK_FORM_INITIAL = { name: '', email: '', service: '', message: '' };

const QUICK_FORM_VALIDATORS = {
  name: validateRequired,
  email: [validateRequired, validateEmail],
  message: validateRequired,
};

const Footer = () => {
  const { values, errors, status, isSubmitting, handleChange, handleSubmit } = useContactForm({
    initialValues: QUICK_FORM_INITIAL,
    validators: QUICK_FORM_VALIDATORS,
  });

  return (
    <footer className="technumopus-footer">
      <div className="technumopus-container">
        <div className="technumopus-footer-content">
          <div className="technumopus-footer-brand">
            <div className="technumopus-footer-logo">
              <div className="technumopus-logo-wrapper">
                <img src={Technumnewlogowhite} alt="Technum Opus" loading="lazy" decoding="async" />
              </div>
            </div>
            <p className="technumopus-footer-eri">
              Building Onified.ai, the ERI platform for manufacturing.
            </p>
            <div className="technumopus-contact-info">
              <p><strong>Technum Opus Private Limited</strong></p>
              <p><strong>CIN:</strong> U72900HR2022PTC107451</p>
              <p><strong>Registered Office:</strong></p>
              <p>1601, Tower 4, Unitech Harmony,<br />
                Nirvana Country, Sector 50,<br />
                Gurugram – 122018, Haryana, India</p>
              <p><strong>Corporate Office:</strong></p>
              <p>1502, 15th Floor,<br />
                M3M International Financial Center (IFC),<br />
                Sector 66, Golf Course Extension Road,<br />
                Gurugram – 122101, Haryana, India</p>
              <p className="technumopus-contact-item">
                <img src={FooterliMail} alt="Email" className="technumopus-contact-icon" loading="lazy" decoding="async" />
                <a href="mailto:connect@technumopus.com">connect@technumopus.com</a>
              </p>
              <p className="technumopus-contact-item">
                <img src={FooterliPhone} alt="Phone" className="technumopus-contact-icon" loading="lazy" decoding="async" />
                <a href="tel:+918700579310">+91 8700579310</a>
              </p>
            </div>
            <div className="technumopus-social-links">
              <Link to="" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </Link>
            </div>
          </div>
          
          <div className="technumopus-footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="digital-transformation">Digital Transformation</Link></li>
              <li><Link to="computer-vision">Computer Vision Intelligence</Link></li>
              <li><Link to="industry-4-0">Industry 4.0 Implementation</Link></li>
              <li><Link to="cloud-migration">Cloud Migration</Link></li>
              {/* <li><Link to="automation">Automation Solutions</Link></li> */}
              <li><Link to="technology-infrastructure">Technology Infrastructure</Link></li>
            </ul>
          </div>
          
          <div className="technumopus-footer-section">
            <h4>Industries</h4>
            <ul>
              <li><Link to="textiles-apparel">Textiles & Apparel</Link></li>
              <li><Link to="precision-manufacturing">Precision Manufacturing</Link></li>
              <li><Link to="process-industries">Process Industries</Link></li>
              <li><Link to="materials-finishing">Materials & Finishing</Link></li>
            </ul>
          </div>
          
          <div className="technumopus-footer-section">
            <h4>Company</h4>
            <ul>
              <li><Link to="about-us">About Us</Link></li>
              <li><Link to="case-studies">Case Studies</Link></li>
              <li><Link to="blog">Blog</Link></li>
              <li><a href="https://www.onified.ai" target="_blank" rel="noopener noreferrer" className="technumopus-footer-onified-link">Onified.ai <span aria-hidden="true">&#8599;</span></a></li>
              <li><Link to="contact">Contact</Link></li>
              <li><Link to="careers">Careers</Link></li>
            </ul>
          </div>
          
          <div className="technumopus-footer-section">
            <h4>Quick Contact</h4>
            <form
              className="tf-form tf-form--dark tf-form--compact technumopus-quick-form"
              onSubmit={handleSubmit}
              noValidate
              aria-label="Quick contact form"
            >
              <FormField
                name="name"
                label="Your name"
                value={values.name}
                onChange={handleChange}
                error={errors.name}
                disabled={isSubmitting}
                autoComplete="name"
                placeholder="Jane Doe"
                required
              />
              <FormField
                name="email"
                type="email"
                label="Work email"
                value={values.email}
                onChange={handleChange}
                error={errors.email}
                disabled={isSubmitting}
                autoComplete="email"
                placeholder="you@company.com"
                required
              />
              <FormSelect
                name="service"
                label="What can we help with?"
                value={values.service}
                onChange={handleChange}
                options={SERVICE_OPTIONS.filter((opt) => opt.value !== 'CAREERS')}
                placeholder="Choose a service (optional)"
                error={errors.service}
                disabled={isSubmitting}
                hint="Leave blank if you're not sure yet."
              />
              <FormTextarea
                name="message"
                label="How can we help?"
                value={values.message}
                onChange={handleChange}
                error={errors.message}
                disabled={isSubmitting}
                rows={3}
                placeholder="Tell us briefly what you're working on."
                required
              />
              <FormStatus type={status.type} message={status.message} />
              <SubmitButton
                isLoading={isSubmitting}
                label="Send message"
                loadingLabel="Sending…"
                block
              />
            </form>
          </div>
        </div>
        
        <div className="technumopus-footer-aws">
          <div className="technumopus-footer-aws-left">
            <img src={AwsLogo} alt="AWS Partner" className="technumopus-footer-aws-logo" loading="lazy" decoding="async" />
            <div className="technumopus-footer-aws-text">
              <span className="technumopus-footer-aws-title">Official AWS Partner</span>
              <span className="technumopus-footer-aws-desc">
                AWS Solution Provider — consolidated INR billing, 24/7 managed operations, and 20–37% typical savings on your AWS bill. CERT-In and DPDPA 2023 compliant by default.
              </span>
            </div>
          </div>
          <Link to="aws-partner" className="technumopus-footer-aws-cta">
            Learn More
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
        </div>

        <div className="technumopus-footer-bottom">
          <p>© 2026 Technum Opus Pvt Ltd. All rights reserved.</p>
          <div className="technumopus-footer-links">
            <Link to="privacy-policy">Privacy Policy</Link>
            <Link to="terms-of-service">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;